<template>
  <div class="productFiles">
    <div class="productFiles__inner">
      <h3 class="productFiles__title">
        {{ title }}
      </h3>
      <div class="productFiles__files">
        <file-downloader
          v-for="(file, index) in files"
          :key="index"
          :url="file.url"
          :name="file.title"
          :type="file.extension"
          :size="file.size"
          with-button
          download
          target="_blank"
          class="productFiles__file"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FileDownloader from '~/components/FileDownloader';

export default {
  name: 'ProductFiles',
  components: { FileDownloader },
  props: {
    title: {
      type: String,
      default: '',
    },
    files: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.productFiles {
  $root: &;

  @include rwd('small-tablet') {
    padding-bottom: 3.5rem;
  }

  &__files {
    max-width: 660px;
  }

  &__file {
    position: relative;
    margin-bottom: 1rem;
    padding: 1rem 1rem 1rem 2rem;
    border: 1px solid $cAddLight;
    border-radius: 3px;
    overflow: hidden;
    transition: background $tr;

    &:last-child {
      margin-bottom: 0;
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(180deg, #ffffff 0%, #f7f8fc 100%);
      opacity: 0;
      transition: opacity $tr;
    }

    &:hover {
      &:before {
        opacity: 1;
      }
    }
  }
}
</style>
